module.exports = "<div class=\"gmao-center\">\r\n    <md-button class=\"md-fab md-mini\">\r\n        {{$ctrl.user.username| limitTo:1 | uppercase}}\r\n        <md-tooltip>{{$ctrl.user.username}}</md-tooltip>\r\n    </md-button>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/gmao-user.html
// module id = 302
// module chunks = 1